// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiPoll/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiPoll/getRows', payload).then(getData);

export const create = (row) => http.post('apiPoll/create', row).then(getData);

export const update = (row) => http.post('apiPoll/edit', row).then(getData);

export const remove = (row) => http.post('apiPoll/delete', row).then(getData);